import React, { useEffect, useState } from "react";
import "../../css/RegionWiseReport.css";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import TablePagination from "@mui/material/TablePagination";
import { NavLink, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import excel from '../../Assets/images/excel.png'
import search from '../../Assets/images/search.png'
import CustomDateRangePicker from "../../components/DatePickerPastDates";
import { useUIContext } from "../../context";

const RegionWise_report_user = () => {
  const [data, setData] = useState([]);
  const [snackBar, setSnackBar] = useState({ open: false, severity: "", message: "" });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalTemplates, setTotalTemplates] = useState(0);
  // const [fromdate, setFromDate] = useState(null);
  // const [todate, setToDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [isToDateEnabled, setIsToDateEnabled] = useState(false);



  const { dateRanges } = useUIContext();
  const dates = dateRanges.mis.map(date => {
    if (!date) return undefined;

    const localDate = new Date(date);
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0");
    const day = String(localDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  });

  const [fromdate, todate] = dates;

  // Get current date and calculate 2 months ago
  const today = new Date();
  const todayString = today.toISOString().split("T")[0];
  const twoMonthsAgo = new Date(today);
  twoMonthsAgo.setMonth(today.getMonth() - 2);
  const twoMonthsAgoString = twoMonthsAgo.toISOString().split("T")[0];

  // const handleFromDateChange = (event) => {
  //   const selectedFromDate = event.target.value;
  //   setFromDate(selectedFromDate);
  //   setIsToDateEnabled(!!selectedFromDate);
  // };

  // const handleToDateChange = (event) => {
  //   setToDate(event.target.value);
  // };



  useEffect(() => {
  if (fromdate && todate) {
    Getdatetodata();
  } else {
    getTemplates();
  }
}, [page, rowsPerPage, fromdate, todate]);

  // Search with date filter
  const Getdatetodata = async () => {
    if (!fromdate) {
      setSnackBar({
        open: true,
        severity: "warning",
        message: "Please select from date first"
      });
      return;
    }

    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/reports/Searh_button_api_region_user?page=${page + 1}&limit=${rowsPerPage}`,
        method: "post",
        payload: { fromdate, todate }
      });

      if (res?.success) {
        setData(res.data || []);
        setTotalTemplates(res.pagination?.total || res.data.length || 0);
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: "error",
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetching templates data from API
  const getTemplates = async () => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/reports/getURL_data_user?page=${page + 1}&limit=${rowsPerPage}`,
        method: "GET",
      });

      if (res?.success) {
        setData(res.data || []);
        setTotalTemplates(res.pagination?.total || res.data.length || 0);
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: "error",
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
      if (!fromdate && !todate){
getTemplates();
      }
    
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Navigate to zone report when region is clicked
  const handleNavigateToZones = (region) => {
    navigate(`/admin/zone-wise-report?region=${encodeURIComponent(region)}`, {
      state: {
        fromdate: fromdate,
        todate: todate,
        region: region
      }
    });
  };

  // Navigate to the detailed region report page (for counts - future feature)
  const handleNavigateToDetails = (region, columnName) => {
    // Currently disabled, can be enabled in future
    // navigate(`/UserDetailspage?region=${encodeURIComponent(region)}&columnName=${encodeURIComponent(columnName)}`, {
    //   state: {
    //     fromdate: fromdate,
    //     todate: todate,
    //   },
    // });
  };

  // Calculate totals for all regions
  const calculateTotals = () => {
    return data.reduce(
      (totals, region) => ({
        total_send: totals.total_send + (region.total_send || 0),
        total_delivered: totals.total_delivered + (region.total_delivered || 0),
        total_failed: totals.total_failed + (region.total_failed || 0),
        total_seen: totals.total_seen + (region.total_seen || 0),
      }),
      {
        total_send: 0,
        total_delivered: 0,
        total_failed: 0,
        total_seen: 0,
      }
    );
  };



  const totals = calculateTotals();

  // Export data to CSV
  const exportToCSV = () => {
    const header = [
      "Region",
      "Total Send",
      "Total Delivered",
      "Total Failed",
      "Total Seen",
      // "Sub Total"
    ];


    const rows = data.map(region => {
      const subTotal =
        (region.total_send || 0) +
        (region.total_delivered || 0) +
        (region.total_failed || 0) +
        (region.total_seen || 0);

      return [
        region.region || "Unknown",
        region.total_send || 0,
        region.total_delivered || 0,
        region.total_failed || 0,
        region.total_seen || 0,
        subTotal,
      ];
    });


    // Add the totals row at the end
    rows.push([
      "Total",
      totals.total_send,
      totals.total_delivered,
      totals.total_failed,
      totals.total_seen,
      totals.total_send + totals.total_delivered + totals.total_failed + totals.total_seen,
    ]);


    // Create CSV data
    const csvContent = [
      header.join(","),
      ...rows.map(row => row.join(","))
    ].join("\n");

    // Trigger file download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "region_report.csv");
  };

  return (
    <>
      <div className="Template_id_contian1">
        <h4 className="Head_titleTemplate">
          {/* ✅ Replace old from-to date with Custom DateRange */}
          <div className="DateRangeContain flex items-center">
            <CustomDateRangePicker rangeKey="mis" />
            <button
              type="button"
              className="SearchDateRange"
              onClick={Getdatetodata}
            >
              <img src={search} alt="Search" className="w-5 h-5" />
            </button>
          </div>

          <span className="Head_titleTemplate_22">
            View Region Report
          </span>

          <div
            onClick={exportToCSV}
            className="excel_button"
          >
            <img src={excel} alt="export" className="w-6 h-6" />
          </div>
        </h4>


        {loading && <div className="loading-spinner">Loading...</div>}

        <div className="Template_id_Card1">
          <div className="table_contain" id="tableContain">
            <table className="Table w-100" id="Table">
              <thead>
                <tr>
                  <th>Region</th>
                  <th>Total Send</th>
                  <th>Total Delivered</th>
                  <th>Total Failed</th>
                  <th>Total Seen</th>
                  {/* <th>Sub Total</th> */}
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                      {loading ? 'Loading...' : 'No data available'}
                    </td>
                  </tr>
                ) : (
                  data.map((region, index) => {
                    // agar region empty/null/undefined hai to skip kare
                    if (!region.region) return null;

                    const subTotal =
                      (region.total_send || 0) +
                      (region.total_delivered || 0) +
                      (region.total_failed || 0) +
                      (region.total_seen || 0);

                    return (
                      <tr key={index}>
                        {/* Region column is clickable to navigate to zones */}
                        <td>
                          <button
                            className="btn btn-link btn-link1"
                            onClick={() => handleNavigateToZones(region.region)}
                            style={{ textDecoration: 'none', color: '#007bff', cursor: 'pointer' }}
                          >
                            {region.region}
                          </button>
                        </td>

                        {/* Count columns are not clickable for now (future feature) */}
                        <td>{region.total_send || 0}</td>
                        <td>{region.total_delivered || 0}</td>
                        <td>{region.total_failed || 0}</td>
                        <td>{region.total_seen || 0}</td>
                        {/* <td>{subTotal}</td> */}
                      </tr>
                    );
                  })
                )}

                {data.length > 0 && (
                  <tr className="font-weight-bold">
                    <td><b>Total</b></td>
                    <td><b>{totals.total_send}</b></td>
                    <td><b>{totals.total_delivered}</b></td>
                    <td><b>{totals.total_failed}</b></td>
                    <td><b>{totals.total_seen}</b></td>
                    {/* <td>
        <b>
          {totals.total_send +
            totals.total_delivered +
            totals.total_failed +
            totals.total_seen}
        </b>
      </td> */}
                  </tr>
                )}
              </tbody>

            </table>

            {totalTemplates > 0 && (
              <TablePagination
                component="div"
                count={totalTemplates}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            )}
          </div>
        </div>
      </div>
      <ShowSnackBar open={snackBar.open} severity={snackBar.severity} message={snackBar.message} />
    </>
  );
};

export default RegionWise_report_user;